import { render, staticRenderFns } from "./PeraltaUserAgreement.vue?vue&type=template&id=82dd1c04&"
import script from "./PeraltaUserAgreement.vue?vue&type=script&lang=ts&"
export * from "./PeraltaUserAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports